<template lang="pug">
#customize
  alert-popup(v-if="$route.params.page !== 'onlineservice'" :q="4")
  .container.custom_container_lg
    .row
      .col-12
        .html_content(v-html="pageData.HtmlContent")
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import { getCustomizePage } from "@/json/customize";
import AlertPopup from "@/components/common/AlertPopup";

export default {
  name: "Customize",
  metaInfo() {
    return {
      title: (this.pageData && this.pageData.SEO_Title) || "Customize",
      meta: [{ name: "description", content: (this.pageData && this.pageData.SEO_Description) || "" }],
    };
  },
  components: {
    "custom-footer": CustomFooter,
    AlertPopup,
  },
  data() {
    return {
      pageData: {},
    };
  },

  watch: {
    // 同一路由不同 params 時會重用元件，監聽 params 變更以重新載入
    '$route.params.page'(to, from) {
      if (to !== from) {
        this.initPage();
      }
    },
  },

  created() {
    this.initPage();
  },

  mounted() {},

  methods: {
    initPage() {
      const name = String(this.$route?.params?.page || "").trim();
      if (!name) {
        // 沒帶參數就不打 request（若要預設導到 onlineservice，可在此做 replace）
        // this.$router.replace({ name: "Customize", params: { page: "onlineservice" } });
        return;
      }
      getCustomizePage(name).then((response) => {
        // 用新物件覆蓋，避免 Vue 判斷為同一參考不重渲染
        this.pageData = { ...(response?.data || {}) };
        
        // 處理 Menu 欄位，設定導航焦點
        const menuIndex = this.pageData?.Menu;
        if (typeof menuIndex === 'number' && menuIndex >= 0 && menuIndex <= 3) {
          this.$store.commit('setCustomizeMenuIndex', menuIndex);
        } else {
          // 預設為 3 (公平待客)
          this.$store.commit('setCustomizeMenuIndex', 3);
        }
      }).catch((err) => {
        console.error("[Customize] load json failed:", err);
        this.pageData = {};
      });
    },
  },
};
</script>
